import { useSelector } from 'react-redux';
import ChorkiBotLogo from '../../../assets/chorki_bot.svg';
import { commonState } from '../../../app/base/commonSlice';

function ChatbotHeader() {
  const { chatbotStart, language } = useSelector(commonState);

  return (
    <div>
      {chatbotStart ? (
        <div className="border-b-[1px] flex pt-4 px-4">
          <div className="mr-4">
            <img className="w-[80px] h-[80px]" src={ChorkiBotLogo} alt="" />
          </div>
          <div className="mt-6">
            <div className="font-bold text-[20px]">
              {language === 'en' ? 'ChorkiBot' : 'চর্কিবট'}
            </div>
            <div className="text-[#767676]">
              {language === 'en'
                ? 'ChatBot / your MyBRAC guide'
                : 'চ্যাটবট / আপনার মাইব্র্যাক সাহায্যকারী'}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default ChatbotHeader;
